import React from "react";
import "./bottombar.css";
import packageJson from "../../../../../package.json";

const MainBottomBar = () => {

  return (
    <div className="main-bottombar-wrapper">
      <div id="main-bottombar-project-title">
        Ràdio Palamós
      </div>
      <div id="main-bottombar-last-refresh">
        v{packageJson.version}
      </div>
    </div>
  );
};

export default MainBottomBar;
